import i18n from 'i18n'
import { useState } from 'react'

export default function PartialAnnotation(shrimpAges: number[]) {
  const [label, setLabel] = useState<Record<number, string>>({})
  const PARTIAL = i18n.t('common:chart.partial')

  return shrimpAges.map((age) => ({
    x: age,
    borderColor: '#919EAB',
    label: {
      mouseEnter: () => {
        const current = label[age] || PARTIAL
        if (current === PARTIAL) {
          setLabel((prev) => ({ ...prev, [age]: i18n.t('common:chart.partial.shrimp.age', { age }) }))
        }
      },
      mouseLeave: () => {
        const current = label[age] || PARTIAL
        if (current !== PARTIAL) {
          setLabel((prev) => ({ ...prev, [age]: PARTIAL }))
        }
      },
      borderColor: '#919EAB',
      style: {
        color: '#fff',
        background: '#919EAB',
      },
      text: label[age] || PARTIAL,
    },
  }))
}
